import * as React from 'react';
import { cva } from 'class-variance-authority';
import { cn } from '@/lib/utils';
import { ReactComponent as Star } from './img/fi-star.svg';

const StarRating = React.forwardRef(({ rate, setRate, onClick, className, ...props }, ref) => {
  const stars = [...Array(5)];

  return (
    <StarRatingWrapper
      ref={ref}
      {...props}
    >
      {stars.map((_, index) => {
        const current = index + 1;

        return (
          <StarRatingButton
            key={index}
            rate={rate >= current}
            onClick={() => {
              setRate(current);
              onClick();
            }}
            onMouseEnter={() => setRate(current)}
            onMouseLeave={() => setRate(0)}
          >
            <StarRatingStar />
          </StarRatingButton>
        );
      })}
    </StarRatingWrapper>
  );
});
StarRating.displayName = 'StarRating';

const starRatingButtonVariants = cva('flex', {
  variants: {
    rate: {
      true: '[&_svg]:fill-[#FFD661]'
    }
  },
  defaultVariants: {
    rate: false
  }
});

const StarRatingButton = React.forwardRef(({ className, rate, ...props }, ref) => (
  <button
    ref={ref}
    type="button"
    className={cn('c-star-button', starRatingButtonVariants({ rate }), 'px-2 bg-transparent border-none outline-none cursor-pointer', className)}
    {...props}
  />
));
StarRatingButton.displayName = 'StarRatingButton';

const StarRatingStar = React.forwardRef(({ className, ...props }, ref) => (
  <Star
    className={cn('c-star-rating-star', 'w-11 text-[#FFD661]', className)}
    ref={ref}
    {...props}
  />
));
StarRatingStar.displayName = 'StarRatingStar';

const StarRatingWrapper = React.forwardRef(({ className, rate, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('c-rating-wrapper', 'flex', className)}
    {...props}
  />
));
StarRatingWrapper.displayName = 'StarRatingWrapper';

export { StarRating, StarRatingButton, StarRatingStar, StarRatingWrapper };
